const attributeKeys = {
  attributes: ["attributes"],
  singleResource: (resourceRef) => [
    ...attributeKeys.attributes,
    resourceRef,
    "singleResource",
  ],
};

export default attributeKeys;
